import { render, staticRenderFns } from "./UploadPublishedDoc.vue?vue&type=template&id=777aaf18&"
import script from "./UploadPublishedDoc.vue?vue&type=script&lang=js&"
export * from "./UploadPublishedDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports